// extracted by mini-css-extract-plugin
module.exports = {"full-screen-loader":"loader_full-screen-loader__2GGpy","panel-loader":"loader_panel-loader__1Ol_n","spacer":"loader_spacer__v2NW5"};